export default __webpack_public_path__ + "static/media/product-image-hover-24.febf1211.jpg";